import { getMethodNames } from "./getMethodNames";

/**
 * [Mutator] Bind all methods to their parent object.
 * @param boundObj - "this" object to bind all functions to.
 * @param methodObj - optional object to grab methods from.
 */
export function bindAll(boundObj: any, methodObj?: any) {
    if (!methodObj) methodObj = boundObj;
    getMethodNames(methodObj).forEach(key => boundObj[key] = methodObj[key].bind(boundObj));  // Bind each method to the parent object.
}
